<template>
  <multi-select
    ref="multiSelect"
    v-model="searchText"
    :options="options"
    :selected-options="selectedOptions"
    :placeholder="placeholder"
    @select="onSelect"
    @searchchange="onSearchChange" />
</template>

<script>
import { MultiSelect } from "vue-search-select";

export default {
  name: "MultiSelectWrapper",
  components: {
    MultiSelect,
  },
  props: {
    placeholder: {
      type: String,
      default: "Select item",
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectedOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchText: "",
    };
  },
  methods: {
    onSelect(items, lastSelectItem) {
      this.$emit("select", items, lastSelectItem);
    },
    onSearchChange(text) {
      if (!this.$refs.multiSelect.showMenu && text.length > 0) {
        this.$refs.multiSelect.openOptions();
      }
    }
  },

};

</script>
